import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GroupsCard from './GroupsCard';

import './Groups.css';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class Groups extends Component {
  componentDidMount = () => {
  };

  selectGroup = group => () => {
    this.props.onSelect({ selected: group.id, group });
    this.props.onGroupChange(group.id);
  };

  selectOrphans = () => {
    this.props.onSelect({ selected: 'orphans' });
    this.props.onGroupChange(null);
  };

  selectAllGroups = () => {
    this.props.onSelect({ selected: 'allgroups' });
    this.props.onGroupChange();
  };

  render() {
    const { translationsStore, groups, carsStore } = this.props;

    return (
      <div className="Groups">
        <GroupsCard
          name="allgroups"
          items={carsStore.groupsCountLength('all')}
          title={translationsStore.translate('groupsManager.groups.aggregatedAllVehicles')}
          description={carsStore.groupsCountLength('all')}
          selected={this.props.selected === 'allgroups'}
          onClick={this.selectAllGroups}
        />
        {!!groups &&
          groups.map(group => (
            <GroupsCard
              name={`group_${group.id}`}
              key={group.id}
              items={carsStore.groupsCountLength('all')}
              title={group.name}
              description={carsStore.groupsCountLength(group.id)}
              selected={this.props.selected === group.id}
              onClick={this.selectGroup(group)}
              disabled={carsStore.groupsCountLength(group.id) === 0}
            />
          ))}
        <GroupsCard
          name="orphans"
          items={carsStore.groupsCountLength('orphans')}
          title={translationsStore.translate('groupsManager.groups.aggregatedUnassignedVehicles')}
          description={carsStore.groupsCountLength('orphans')}
          selected={this.props.selected === 'orphans'}
          onClick={this.selectOrphans}
          theme="alternative"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/Groups/Groups.js